import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function usePDFExport(sectionIds, concatPages, documentName) {
  const printDocument = async () => {
    var PDF_Width = 595.276;
    var PDF_Height = 900.8898;
    var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
    const newElement = document.createElement('div');
    if(!sectionIds?.length){
      let elements = [];
      for (let index = 0; index < concatPages.length; index++) {
        elements.push(document.querySelector(concatPages[index]))
      }
      for (let index = 0; index < elements.length; index++) {
        // Clone and append the existing elements to the new element
        newElement.appendChild(elements[index].cloneNode(true));
      }
      newElement.id = "concated"
      sectionIds.push("#concated")
      document.body.appendChild(newElement);
    }
    for (var j = 1; j <= concatPages.length; j++) {
      var box = document.querySelector(concatPages[j-1]);
      var HTML_Width = box.offsetWidth;
      var HTML_Height = box.offsetHeight;

      var top_left_margin = 10;

      var canvas_image_width = PDF_Width - 2 * top_left_margin;
      var canvas_image_height =
        HTML_Height * ((PDF_Width - 2 * top_left_margin) / HTML_Width);

      var totalPDFPages =
        Math.ceil(canvas_image_height / (PDF_Height - 2 * top_left_margin)) - 1;
      await html2canvas(box, {
        scale: 1.5,
      }).then(function (canvas) {
        canvas.getContext('2d');
        var imgData = canvas.toDataURL('image/jpeg');
        if (j != 1) {
          // pdf.addPage(PDF_Width, PDF_Height);
          pdf.addPage();
        }
        pdf.addImage(
          imgData,
          'JPG',
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, 0, PDF_Width, top_left_margin, 'F');
        pdf.rect(
          0,
          PDF_Height - top_left_margin,
          PDF_Width,
          top_left_margin,
          'F'
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          // pdf.addPage(PDF_Width, PDF_Height);
          pdf.addPage();

          pdf.addImage(
            imgData,
            'JPG',
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * (2 * i + 1),
            canvas_image_width,
            canvas_image_height
          );
          pdf.setFillColor(255, 255, 255);
          pdf.rect(0, 0, PDF_Width, top_left_margin, 'F');
          pdf.rect(
            0,
            PDF_Height - top_left_margin,
            PDF_Width,
            top_left_margin,
            'F'
          );
        }
      });
    }
    pdf.save(documentName);
    document.body.removeChild(newElement);
    sectionIds=[];
  }
  return {
    printDocument
  }
}
